// import { distortionClass, distortionBar } from './index';

const comMainVisual2 = (() => {
  const jsSecMain2 = (document.getElementById("jsSecMain2") != null);
  if (jsSecMain2) {


    let sW = window.innerWidth;
    let sH = window.innerHeight;


    // const jsSecMain = document.getElementById('jsSecMain');
    // const jsMainImgBox = document.getElementById('jsMainImgBox');
    // jsSecMain.style.height = `${sH}px`
    // jsMainImgBox.style.height = `${sH}px`


    window.addEventListener('load', () => {

      setTimeout(() => {
        gsap.to('#jsMainTxt path', {
          opacity: 1,
          duration: 1,
          stagger: {
            amount: 3,
            from: 'random',
          },
          onStart: () => {
            startFunc()
          },
          onComplete: () => {
                console.log('complete');
            gsap.to('#jsMainTxtTtl', {
              opacity: 1,
              duration: 1,
            });
          },
        });
      }, 0)

      const startFunc = () => {
        gsap.to('#jsMainImgBox', {
          opacity: 1,
          duration: .8,
          filter: "blur(0px)",
        });
      }

    });


  }
})();
export default comMainVisual2;